import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Environment } from '@dice/app/types/env.type';
import { ENV } from '@dice/config.tokens';
import { UrlService } from '@uirouter/angular';
import { Observable } from 'rxjs';

/** Http interceptor for setting the correct base url */
@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  private env = inject<Environment>(ENV);
  private urlService = inject(UrlService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let basePath = '';
    let request: HttpRequest<any> = req.clone();

    // do not touch html, translations and asset calls
    if (
      request.url.indexOf('.html') === -1 &&
      request.url.indexOf('assets') === -1 &&
      request.url.indexOf('translations') === -1 &&
      request.url.indexOf('http://') === -1 &&
      request.url.indexOf('https://') === -1 &&
      request.url.indexOf('ws://') === -1 &&
      request.url.indexOf('wss://') === -1
    ) {
      if (this.env.apiEndpoint.substr(0, 4) !== 'http') {
        const { config } = this.urlService;
        basePath = `${config.protocol()}://${config.host()}`;
      }

      // clone request and edit it
      request = request.clone({
        url: basePath + this.env.apiEndpoint + request.url,
      });
    }

    return next.handle(request);
  }
}
